// extracted by mini-css-extract-plugin
export default {"box":"retailerPage_box__4+Tld"};